// import React from "react";

// export default function TalkToExpertModal({ isOpen, onClose }) {
//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center px-4">
//       <div className="bg-white p-6 rounded-xl w-full max-w-sm md:max-w-md relative shadow-xl">
//         <button
//           onClick={onClose}
//           className="absolute top-2 right-3 text-gray-500 hover:text-gray-700 text-2xl"
//         >
//           &times;
//         </button>

//         <h2 className="text-xl font-semibold mb-4 text-center text-black">
//           Talk To An Expert
//         </h2>

//         <form className="space-y-4">
//           <div className="flex flex-col gap-2 md:flex-row">
//             <div className="w-full">
//               <label
//                 htmlFor="company"
//                 className="text-sm text-gray-700 mb-1 block"
//               >
//                 Company Name
//               </label>
//               <input
//                 id="company"
//                 type="text"
//                 placeholder="Company Name"
//                 className="w-full border border-gray-300 rounded-md p-2 text-sm"
//               />
//             </div>
//             <div className="w-full">
//               <label
//                 htmlFor="country"
//                 className="text-sm text-gray-700 mb-1 block"
//               >
//                 Country
//               </label>
//               <input
//                 id="country"
//                 type="text"
//                 placeholder="Country"
//                 className="w-full border border-gray-300 rounded-md p-2 text-sm"
//               />
//             </div>
//           </div>

//           <div className="flex flex-col gap-2 md:flex-row">
//             <div className="w-full">
//               <label
//                 htmlFor="fullname"
//                 className="text-sm text-gray-700 mb-1 block"
//               >
//                 Full Name
//               </label>
//               <input
//                 id="fullname"
//                 type="text"
//                 placeholder="Full Name"
//                 className="w-full border border-gray-300 rounded-md p-2 text-sm"
//               />
//             </div>
//             <div className="w-full">
//               <label
//                 htmlFor="jobtitle"
//                 className="text-sm text-gray-700 mb-1 block"
//               >
//                 Job Title
//               </label>
//               <input
//                 id="jobtitle"
//                 type="text"
//                 placeholder="Job Title"
//                 className="w-full border border-gray-300 rounded-md p-2 text-sm"
//               />
//             </div>
//           </div>

//           <div className="flex flex-col gap-2 md:flex-row">
//             <div className="w-full">
//               <label
//                 htmlFor="email"
//                 className="text-sm text-gray-700 mb-1 block"
//               >
//                 Business Email
//               </label>
//               <input
//                 id="email"
//                 type="email"
//                 placeholder="Business Email"
//                 className="w-full border border-gray-300 rounded-md p-2 text-sm"
//               />
//             </div>
//             <div className="w-full">
//               <label
//                 htmlFor="mobile"
//                 className="text-sm text-gray-700 mb-1 block"
//               >
//                 Mobile Number
//               </label>
//               <input
//                 id="mobile"
//                 type="text"
//                 placeholder="Mobile Number"
//                 className="w-full border border-gray-300 rounded-md p-2 text-sm"
//               />
//             </div>
//           </div>

//           <div>
//             <label
//               htmlFor="serviceType"
//               className="text-sm text-gray-700 mb-1 block"
//             >
//               Type of Service
//             </label>
//             <select
//               id="serviceType"
//               className="w-full border border-gray-300 rounded-md p-2 text-sm"
//             >
//               <option>Hire On-demand</option>
//               <option>Outsource Project</option>
//               <option>Build Offshore CoE</option>
//             </select>
//           </div>

//           <div>
//             <label
//               htmlFor="description"
//               className="text-sm text-gray-700 mb-1 block"
//             >
//               Requirements Description
//             </label>
//             <textarea
//               id="description"
//               placeholder="Describe your Resource-as-a-Service requirement..."
//               rows="3"
//               className="w-full border border-gray-300 rounded-md p-2 text-sm"
//             ></textarea>
//           </div>

//           <button
//             type="submit"
//             className="w-full bg-[#5c68f2] hover:bg-[#ba195f] transition-colors duration-200 text-white py-2 rounded-md font-medium"
//           >
//             Submit
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// }

import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

export default function TalkToExpertModal({ isOpen, onClose }) {
  const form = useRef();
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  if (!isOpen) return null;

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);

    emailjs
      .sendForm(
        "service_yr27zms",     // Replace with your EmailJS Service ID
        "template_a1ntf5h",    // Replace with your EmailJS Template ID
        form.current,
        "4lbCjPNxpAcxPIevV"      // Replace with your EmailJS Public Key
      )
      .then(
        (result) => {
          setLoading(false);
          setSent(true);
          form.current.reset();
        },
        (error) => {
          console.error(error.text);
          setLoading(false);
        }
      );
  };

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center px-4">
      <div className="bg-white p-6 rounded-xl w-full max-w-sm md:max-w-md relative shadow-xl">
        <button
          onClick={onClose}
          className="absolute top-2 right-3 text-gray-500 hover:text-gray-700 text-2xl"
        >
          &times;
        </button>

        <h2 className="text-xl font-semibold mb-4 text-center text-black">
          Talk To An Expert
        </h2>

        {sent ? (
          <p className="text-green-600 text-center mb-4">
            ✅ Message sent successfully!
          </p>
        ) : null}

        <form ref={form} onSubmit={sendEmail} className="space-y-4">
          <div className="flex flex-col gap-2 md:flex-row">
            <div className="w-full">
              <label className="text-sm text-gray-700 mb-1 block">Company Name</label>
              <input name="company_name" type="text" required className="w-full border border-gray-300 rounded-md p-2 text-sm" />
            </div>
            <div className="w-full">
              <label className="text-sm text-gray-700 mb-1 block">Country</label>
              <input name="country" type="text" required className="w-full border border-gray-300 rounded-md p-2 text-sm" />
            </div>
          </div>

          <div className="flex flex-col gap-2 md:flex-row">
            <div className="w-full">
              <label className="text-sm text-gray-700 mb-1 block">Full Name</label>
              <input name="full_name" type="text" required className="w-full border border-gray-300 rounded-md p-2 text-sm" />
            </div>
            <div className="w-full">
              <label className="text-sm text-gray-700 mb-1 block">Job Title</label>
              <input name="job_title" type="text" className="w-full border border-gray-300 rounded-md p-2 text-sm" />
            </div>
          </div>

          <div className="flex flex-col gap-2 md:flex-row">
            <div className="w-full">
              <label className="text-sm text-gray-700 mb-1 block">Business Email</label>
              <input name="email" type="email" required className="w-full border border-gray-300 rounded-md p-2 text-sm" />
            </div>
            <div className="w-full">
              <label className="text-sm text-gray-700 mb-1 block">Mobile Number</label>
              <input name="mobile" type="text" className="w-full border border-gray-300 rounded-md p-2 text-sm" />
            </div>
          </div>

          <div>
            <label className="text-sm text-gray-700 mb-1 block">Type of Service</label>
            <select name="service_type" className="w-full border border-gray-300 rounded-md p-2 text-sm">
              <option>Hire On-demand</option>
              <option>Outsource Project</option>
              <option>Build Offshore CoE</option>
            </select>
          </div>

          <div>
            <label className="text-sm text-gray-700 mb-1 block">Requirements Description</label>
            <textarea
              name="description"
              rows="3"
              className="w-full border border-gray-300 rounded-md p-2 text-sm"
              placeholder="Describe your Resource-as-a-Service requirement..."
            ></textarea>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#5c68f2] hover:bg-[#ba195f] transition-colors duration-200 text-white py-2 rounded-md font-medium"
          >
            {loading ? "Sending..." : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
}
